import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';

const bulletinsStatistiquesData = [
     {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2023",
    link: "/documents/Annuaires/Annuaire_Statistique_Burundi_Edition_2023.pdf",
    image: "/assets/anuaire2022.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour l'année 2023.",
    date: "2024-12-31"
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2022",
    link: "/documents/Annuaires/Annuaire-Statitistique-du-Burundi-Edition-2022.pdf",
    image: "/assets/anuaire2022.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour l'année 2022.",
    date: "2022-12-31"
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2021",
    link: "/documents/Annuaires/Annuaire-Statistique-du-Burundi-2021vf.pdf",
    image: "/assets/anuaire2021.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour l'année 2021.",
    date: "2021-12-31"
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2020",
    link: "/documents/Annuaires/Annuaire-Statistique-du-Burundi_2020.pdf",
    image: "/assets/anuaire2020.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour 2020.",
    date: "2020-12-31", 
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2019",
    link: "/documents/Annuaires/Annuaire-statistique-2019.pdf",
    image: "/assets/anuaire2019.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour 2019.",
    date: "2019-12-31", 
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2018",
    link: "/documents/Annuaires/Annuaire-2018.pdf",
    image: "/assets/anuaire2018.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour 2018.",
    date: "2018-12-31",
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2017",
    link: "/documents/Annuaires/Annuaire-2017.pdf",
    image: "/assets/anuaire2017.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour 2017.",
    date: "2017-12-31",
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2016",
    link: "/documents/Annuaires/Annuaire-2016.pdf",
    image: "/assets/anuaire2016.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour l'année 2016.",
    date: "2016-12-31",
  },
  {
    title: "ANNUAIRE STATISTIQUE DU BURUNDI ÉDITION 2015",
    link: "/documents/Annuaires/Annuaire-statistique-du-Burundi-2015.pdf",
    image: "/assets/anuaire2015.PNG",
    description: "Un recueil des statistiques économiques, sociales et démographiques du Burundi pour 2015.",
    date: "2015-12-31",
  }
];

function AnnuaireStatistique() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsStatistiquesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredBulletins(bulletinsStatistiquesData);
    } else {
      const filtered = bulletinsStatistiquesData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      setFilteredBulletins(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#673AB7',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54'
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: '#6B778C',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '64px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Annuaires Statistiques
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les annuaires statistiques sont des outils essentiels pour la compréhension et l'analyse des tendances socio-économiques au Burundi. Publiés chaque année, ces recueils regroupent des données fiables et actualisées provenant de divers secteurs d'activité, couvrant des domaines variés comme l'économie, la démographie, la santé et l'éducation.
          </Typography>
          
         
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionner par année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionner par année de publication"
            >
              <MenuItem value="Tous">Tous les annuaires</MenuItem>
              {[...new Set(bulletinsStatistiquesData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a) // Tri par ordre décroissant
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des annuaires */}
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={bulletin.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 51, height: 100, m: 2 }}
                        image={bulletin.image}
                        alt={bulletin.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                    <a
                      href={bulletin.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                      {<DownloadIcon />}{bulletin.title}
                      </Typography>
                      </a>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus d'Annuaires
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default AnnuaireStatistique;